import { useSession } from 'src/providers/auth.provider'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { getBackofficeWorkflowUrl } from 'src/utils/backoffice.util'

export const useNotEditableBackofficeUrl = ({
  id,
  isEditable,
}: {
  id: number
  isEditable: boolean
}): string | null => {
  const { currentUser } = useSession()
  const { project } = useCurrentProject()

  return currentUser?.isAdmin && !isEditable ? getBackofficeWorkflowUrl(project.id, id) : null
}
